var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlayerNote24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_PlayerNote24x24",
    transform: "translate(564 914.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26389",
    transform: "translate(-564 -914.449)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46808",
    d: "M-553.7-911.1a.3.3,0,0,0,0,.4.3.3,0,0,0,.4,0h0l2-2a1.776,1.776,0,0,0,2.5-.4,1.776,1.776,0,0,0-.4-2.5,1.776,1.776,0,0,0-2.5.4,1.8,1.8,0,0,0,0,2.1Z",
    transform: "translate(564.1 915.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46809",
    d: "M-561-912.914c.2-.1.2-.2.2-.392,0-.1-.1-.2-.3-.2l-.8-.1a.263.263,0,0,0-.3.294l-1.8,11.767a.263.263,0,0,0,.3.294h0l2.9.2h0c.1,0,.2,0,.2-.1a.3.3,0,0,0,.1-.2l-1.1-10.688A.858.858,0,0,1-561-912.914Z",
    transform: "translate(564 915.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46810",
    d: "M-547.2-913.605c0-.1,0-.2-.1-.2-.1-.1-.1-.1-.2-.1h-.1c-.1,0-.2.1-.3.2a2.344,2.344,0,0,1-2.3,1.867,2.24,2.24,0,0,1-.8-.1.372.372,0,0,0-.3.1l-1.6,1.572a1.066,1.066,0,0,1-1.3,0,.83.83,0,0,1,0-1.277l1.2-1.179a.357.357,0,0,0,.1-.295c-.1-.1-.2-.2-.3-.2l-7.6.884a.316.316,0,0,0-.3.295h0l1.2,11.79a.263.263,0,0,0,.3.295h0l13.2-1.179a.316.316,0,0,0,.3-.295h0Z",
    transform: "translate(564.1 915.949)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlayerNote24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_PlayerNote24x24.a758a01d7bc2ff3bfa257a4e26631ce6.svg";